import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { ContentTemplateInputRow, ContentTemplateRow } from "namirasoft-content-template";
import { IStorageLocal } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, DateTimeFormatter, EnumFormatter, IDFormatter, JsonFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { ContentTemplateMenus } from "./ContentTemplateMenus";
import { ContentTemplateProps } from "./ContentTemplateProps";
import { ContentTemplateRoutes } from "./ContentTemplateRoutes";

export class ContentTemplateEntities
{
	static content_template(props: NSARouterMakerResult & ContentTemplateProps): IEntityInfo<ContentTemplateRow, ContentTemplateInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, props.notifier.onError);

		return {
			product_id: ProductUUID.NAMIRASOFT_CONTENT_TEMPLATE,
			name: "content_template",
			tables: [{ table: namirasoft.content_template.tables.content_template, required: true }],
			client: {
				getListURL: () => ContentTemplateRoutes.ContentList,
				getNewURL: () => ContentTemplateRoutes.ContentNew,
				getCopyURL: (id: string) => ContentTemplateRoutes.ContentCopy(id),
				getEditURL: (id: string) => ContentTemplateRoutes.ContentEdit(id),
				getViewURL: (id: string) => ContentTemplateRoutes.ContentView(id),
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.content_template.tables.content_template.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.content_template.tables.content_template.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.content_template.tables.content_template.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.content_template.tables.content_template.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.content_template.tables.content_template.columns.type, new EnumFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.content_template.tables.content_template.columns.content, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.content_template.tables.content_template.columns.parameters, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.content_template.tables.content_template.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.content_template.tables.content_template.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.content_template.tables.content_template.columns.updated_at, new DateTimeFormatter())
					];
				},
				getMenus: (getIDs) => { return { "Content Template": [ContentTemplateMenus.make(getIDs)] } }
			},
			server: {
				value_list: props.servers.content_template.value.List,
				get: async (id) =>
				{
					return await props.servers.content_template.content_template.Get(id);
				},
				list: props.servers.content_template.content_template.List,
				create: props.servers.content_template.content_template.Create,
				update: props.servers.content_template.content_template.Update,
				delete: props.servers.content_template.content_template.Delete,
			}
		};
	}
}